import React from "react";
import { FallbackProps } from "react-error-boundary";

import { IgAlert, IgButton } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";

interface AiChatErrorFallbackProps extends FallbackProps {
  onClose?: () => void;
}

export const AiChatErrorFallback: React.FC<AiChatErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
  onClose,
}) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid>
        <IgAlert
          severity="error"
          alertKey={"ai-chat-error"}
          title={"Chat Error"}
          message={
            "Something went wrong with the AI chat. The error has been logged and our team will investigate."
          }
        />
      </Grid>
      <Grid container columnSpacing={1}>
        <Grid>
          <IgButton variant="contained" onClick={resetErrorBoundary}>
            Try Again
          </IgButton>
        </Grid>
        {onClose && (
          <Grid>
            <IgButton variant="outlined" onClick={onClose}>
              Close Chat
            </IgButton>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
